module.exports = __webpack_public_path__ + "img/set_wallpaper_5.3cddc2f5.png";